import React from "react";
import { Link } from "react-router-dom";
import { Flame, AlertTriangle } from "lucide-react";

export default function Terms() {
  return (
    <div className="min-h-screen">
      <header className="border-b border-white/10">
        <div className="max-w-3xl mx-auto px-5 h-16 flex items-center">
          <Link to="/" className="flex items-center gap-2" data-testid="terms-logo">
            <span className="w-8 h-8 rounded-md bg-primary flex items-center justify-center"><Flame className="w-4 h-4 text-white" /></span>
            <span className="font-display text-lg font-bold tracking-tight">DealWisp</span>
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 py-12 prose-legal">
        <div className="flex items-start gap-3 bg-card border border-primary/30 rounded-xl p-4 mb-10" data-testid="terms-draft-notice">
          <AlertTriangle className="w-5 h-5 text-primary shrink-0 mt-0.5" />
          <p className="text-sm text-muted-foreground">
            <strong className="text-foreground">This is a draft.</strong> It reflects what DealWisp actually does today, but every <code>[PLACEHOLDER]</code> below needs a real value, and the whole document needs a lawyer's review before it's published or relied on. It is not legal advice.
          </p>
        </div>

        <h1 className="font-display text-3xl font-bold tracking-tight">Terms of Service</h1>
        <p className="text-sm text-muted-foreground mt-2">Last updated: [PLACEHOLDER: date]</p>

        <section className="mt-8 space-y-4 text-sm text-muted-foreground leading-relaxed">
          <p>These Terms govern your use of DealWisp (the "Service"), operated by <strong className="text-foreground">Treevoxa</strong>, a business registered in <strong className="text-foreground">[PLACEHOLDER: jurisdiction — country/state]</strong> ("we," "us," "our"). By creating an account you agree to these Terms.</p>

          <h2 className="font-display text-xl font-semibold text-foreground pt-4">1. The Service</h2>
          <p>DealWisp lets a business create a profile, list categorized offers and deals, and publish an auto-generated public page (<code>dealwisp.online/b/:slug</code>, or a verified custom domain) that customers can browse. Click activity on offers is tracked for the business's own analytics.</p>

          <h2 className="font-display text-xl font-semibold text-foreground pt-4">2. Accounts &amp; Trial</h2>
          <p>New accounts start on a 14-day free trial. You're responsible for keeping your login credentials secure and for all activity under your account.</p>

          <h2 className="font-display text-xl font-semibold text-foreground pt-4">3. Billing</h2>
          <p>Paid plans are billed manually: you submit a payment reference and proof of payment, and an administrator reviews and approves or rejects it. Approved payments activate the plan for a fixed period; plans do not auto-renew — you submit a new payment when the period ends. [PLACEHOLDER: refund policy].</p>

          <h2 className="font-display text-xl font-semibold text-foreground pt-4">4. Your Content</h2>
          <p>You keep ownership of the business information, images, and offer content you upload. You grant us a license to host and display it as part of operating the Service, including on your public page.</p>

          <h2 className="font-display text-xl font-semibold text-foreground pt-4">5. Acceptable Use</h2>
          <p>Don't use the Service to list unlawful offers, infringe others' rights, or attempt to abuse or disrupt the platform (including artificially inflating click counts — automated clicks are throttled and may result in suspension).</p>

          <h2 className="font-display text-xl font-semibold text-foreground pt-4">6. Termination</h2>
          <p>You may stop using the Service at any time. We may suspend or terminate accounts that violate these Terms. [PLACEHOLDER: data retention period after termination].</p>

          <h2 className="font-display text-xl font-semibold text-foreground pt-4">7. Disclaimers &amp; Liability</h2>
          <p>The Service is provided "as is." [PLACEHOLDER: liability limitation language — jurisdiction-specific, needs legal drafting].</p>

          <h2 className="font-display text-xl font-semibold text-foreground pt-4">8. Governing Law</h2>
          <p>[PLACEHOLDER: governing law and dispute resolution — jurisdiction-specific].</p>

          <h2 className="font-display text-xl font-semibold text-foreground pt-4">9. Changes</h2>
          <p>We may update these Terms; continued use after a change means you accept the update.</p>

          <h2 className="font-display text-xl font-semibold text-foreground pt-4">10. Contact</h2>
          <p>Questions about these Terms: [PLACEHOLDER: contact email].</p>
        </section>
      </main>
    </div>
  );
}
